import axios from "axios";
import { API } from "../../../api/api";
import { TSolution } from "../../../types/index";
import qs from 'qs';

const query = qs.stringify({
  populate: {
    hero: { populate: '*' },
    optionalIndividualHeroBg: { populate: '*' },
    dynamic: {
      on: {
        'software-solutions.explanation': {
          populate: '*',
        },
        'software-solutions.image': {
          populate: {
            image: { populate: '*' },
          },
        },
        'software-solutions.disadvantage': {
          populate: {
            heading: { populate: '*' },
            cards: { populate: '*' },
          },
        },
        'software-solutions.text-slider': {
          populate: {
            textFields: { populate: '*' },
          },
        },
        'software-solutions.project-selection': {
          populate: {
            heading: { populate: '*' },
            projects: { populate: '*' },
          },
        },
        'software-solutions.faq': {
          populate: {
            heading: { populate: '*' },
            faqItem: { populate: '*' },
          },
        },
        'software-solutions.software-functions': {
          populate: {
            coreFunctions: { populate: '*' },
            extensions: { populate: '*' },
          },
        },
         'software-solutions.standard-chaos': {
          populate: {
            heading: { populate: '*' },
            problem_card: { populate: '*' },
          },
        },
      },
    },
  },
}, {
  encodeValuesOnly: true, // Wichtig für Strapi!
});

export const getSolutionDetail = async (id: string) =>
  await axios.get(`${API.url}/software-solutions/${id}?${query}`).then((res) => res.data?.data?.attributes as TSolution);

const previewCardsQuery = qs.stringify({
  populate: {
    previewCard: { populate: '*' },
  },
}, {
  encodeValuesOnly: true,
});

export const getAllSolutionsPreviewCards = async () =>
  await axios.get(`${API.url}/software-solutions?${previewCardsQuery}`).then((res) => res.data?.data);
